module.exports = __webpack_public_path__ + "assets/screen_desktop.c1887738.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/screen_desktop.png
// module id = 276
// module chunks = 1